// src/pages/Contact.js
import React from "react";
import {Typography, Button, Box } from "@mui/material";

const Contact = () => {
  const handleRedirectToInstagram = () => {
    window.open(
      "https://www.instagram.com/_whimssicalstitches?igsh=bDhnZWZqNmZxeWJ1",
      "_blank"
    );
  };

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          top: 0,
          left: 0,
          width: "98.9vw", 
          height: "40vh", 
          backgroundImage: "url(/contact.jpg)",
          backgroundColor: "lavenderblush",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden", 
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
          textAlign: "center",
          zIndex: -1,
        }}
      >
        <Box sx={{ textAlign: "center", zIndex: 1 }}>
          <Typography variant="h2" gutterBottom>
            Contact Us
          </Typography>
        </Box>
      </Box>
      <Box sx={{ textAlign: "center", mt: 5 }}>
        <Typography variant="body1" paragraph>
          <p>Do you need custome items?</p>
          <p>Do you need assistance or have any questions?</p>
          <p>
            Do you have a picture inspo that talks to the kind of crochet item
            you need?
          </p>
          Send us a message on Instagram and we'll repond to you ASAP
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleRedirectToInstagram}
          sx={{
                backgroundColor:'#16014f',
                '&:hover':{backgroundColor:'#d75efb',
                },
                }}
        >
          Send Message on Instagram
        </Button>
      </Box>
    </Box>
  );
};

export default Contact;


